"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddProductToCurrentInventoryRequest", {
  enumerable: true,
  get: function get() {
    return _AddProductToCurrentInventoryRequest["default"];
  }
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient["default"];
  }
});
Object.defineProperty(exports, "AppResourcesAwaitingValidationOrdersSchemasNeedsRange", {
  enumerable: true,
  get: function get() {
    return _AppResourcesAwaitingValidationOrdersSchemasNeedsRange["default"];
  }
});
Object.defineProperty(exports, "AppResourcesInventoriesSchemasProduct", {
  enumerable: true,
  get: function get() {
    return _AppResourcesInventoriesSchemasProduct["default"];
  }
});
Object.defineProperty(exports, "AppResourcesProductsSchemasProduct", {
  enumerable: true,
  get: function get() {
    return _AppResourcesProductsSchemasProduct["default"];
  }
});
Object.defineProperty(exports, "AppResourcesPurchaseOrdersSchemasNeedsRange", {
  enumerable: true,
  get: function get() {
    return _AppResourcesPurchaseOrdersSchemasNeedsRange["default"];
  }
});
Object.defineProperty(exports, "AwaitingDeliveryOrdersApi", {
  enumerable: true,
  get: function get() {
    return _AwaitingDeliveryOrdersApi["default"];
  }
});
Object.defineProperty(exports, "AwaitingDeliveryProductOrder", {
  enumerable: true,
  get: function get() {
    return _AwaitingDeliveryProductOrder["default"];
  }
});
Object.defineProperty(exports, "AwaitingValidationOrder", {
  enumerable: true,
  get: function get() {
    return _AwaitingValidationOrder["default"];
  }
});
Object.defineProperty(exports, "AwaitingValidationOrdersApi", {
  enumerable: true,
  get: function get() {
    return _AwaitingValidationOrdersApi["default"];
  }
});
Object.defineProperty(exports, "AwaitingValidationProductOrder", {
  enumerable: true,
  get: function get() {
    return _AwaitingValidationProductOrder["default"];
  }
});
Object.defineProperty(exports, "BackendIssue", {
  enumerable: true,
  get: function get() {
    return _BackendIssue["default"];
  }
});
Object.defineProperty(exports, "Category", {
  enumerable: true,
  get: function get() {
    return _Category["default"];
  }
});
Object.defineProperty(exports, "CreateAwaitingDeliveryProductOrderRequest", {
  enumerable: true,
  get: function get() {
    return _CreateAwaitingDeliveryProductOrderRequest["default"];
  }
});
Object.defineProperty(exports, "CreateAwaitingValidationProductOrderRequest", {
  enumerable: true,
  get: function get() {
    return _CreateAwaitingValidationProductOrderRequest["default"];
  }
});
Object.defineProperty(exports, "CreateInventoryRequest", {
  enumerable: true,
  get: function get() {
    return _CreateInventoryRequest["default"];
  }
});
Object.defineProperty(exports, "CreateOrUpdateSubstituteRuleProductRequest", {
  enumerable: true,
  get: function get() {
    return _CreateOrUpdateSubstituteRuleProductRequest["default"];
  }
});
Object.defineProperty(exports, "CreateOrUpdateSubstituteRuleRequest", {
  enumerable: true,
  get: function get() {
    return _CreateOrUpdateSubstituteRuleRequest["default"];
  }
});
Object.defineProperty(exports, "CurrencyCodeEnum", {
  enumerable: true,
  get: function get() {
    return _CurrencyCodeEnum["default"];
  }
});
Object.defineProperty(exports, "DisableOutOfStockRequest", {
  enumerable: true,
  get: function get() {
    return _DisableOutOfStockRequest["default"];
  }
});
Object.defineProperty(exports, "EnableOutOfStockRequest", {
  enumerable: true,
  get: function get() {
    return _EnableOutOfStockRequest["default"];
  }
});
Object.defineProperty(exports, "Forbidden", {
  enumerable: true,
  get: function get() {
    return _Forbidden["default"];
  }
});
Object.defineProperty(exports, "InternalServerError", {
  enumerable: true,
  get: function get() {
    return _InternalServerError["default"];
  }
});
Object.defineProperty(exports, "InventoriesApi", {
  enumerable: true,
  get: function get() {
    return _InventoriesApi["default"];
  }
});
Object.defineProperty(exports, "Inventory", {
  enumerable: true,
  get: function get() {
    return _Inventory["default"];
  }
});
Object.defineProperty(exports, "LocalizedProduct", {
  enumerable: true,
  get: function get() {
    return _LocalizedProduct["default"];
  }
});
Object.defineProperty(exports, "LocalizedProductPage", {
  enumerable: true,
  get: function get() {
    return _LocalizedProductPage["default"];
  }
});
Object.defineProperty(exports, "LocalizedProductsApi", {
  enumerable: true,
  get: function get() {
    return _LocalizedProductsApi["default"];
  }
});
Object.defineProperty(exports, "OutOfStock", {
  enumerable: true,
  get: function get() {
    return _OutOfStock["default"];
  }
});
Object.defineProperty(exports, "OutOfStockPage", {
  enumerable: true,
  get: function get() {
    return _OutOfStockPage["default"];
  }
});
Object.defineProperty(exports, "OutOfStockProduct", {
  enumerable: true,
  get: function get() {
    return _OutOfStockProduct["default"];
  }
});
Object.defineProperty(exports, "OutOfStocksApi", {
  enumerable: true,
  get: function get() {
    return _OutOfStocksApi["default"];
  }
});
Object.defineProperty(exports, "PricingStrategy", {
  enumerable: true,
  get: function get() {
    return _PricingStrategy["default"];
  }
});
Object.defineProperty(exports, "ProductCurrentStock", {
  enumerable: true,
  get: function get() {
    return _ProductCurrentStock["default"];
  }
});
Object.defineProperty(exports, "ProductNeeds", {
  enumerable: true,
  get: function get() {
    return _ProductNeeds["default"];
  }
});
Object.defineProperty(exports, "ProductProvider", {
  enumerable: true,
  get: function get() {
    return _ProductProvider["default"];
  }
});
Object.defineProperty(exports, "ProductSubstitute", {
  enumerable: true,
  get: function get() {
    return _ProductSubstitute["default"];
  }
});
Object.defineProperty(exports, "ProductSubstitutePage", {
  enumerable: true,
  get: function get() {
    return _ProductSubstitutePage["default"];
  }
});
Object.defineProperty(exports, "Provider", {
  enumerable: true,
  get: function get() {
    return _Provider["default"];
  }
});
Object.defineProperty(exports, "ProviderType", {
  enumerable: true,
  get: function get() {
    return _ProviderType["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrder", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrder["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderPage", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderPage["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrdersApi", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrdersApi["default"];
  }
});
Object.defineProperty(exports, "Quantity", {
  enumerable: true,
  get: function get() {
    return _Quantity["default"];
  }
});
Object.defineProperty(exports, "SearchOutOfStockRequest", {
  enumerable: true,
  get: function get() {
    return _SearchOutOfStockRequest["default"];
  }
});
Object.defineProperty(exports, "SubstituteProduct", {
  enumerable: true,
  get: function get() {
    return _SubstituteProduct["default"];
  }
});
Object.defineProperty(exports, "SubstituteRule", {
  enumerable: true,
  get: function get() {
    return _SubstituteRule["default"];
  }
});
Object.defineProperty(exports, "SubstituteRulePage", {
  enumerable: true,
  get: function get() {
    return _SubstituteRulePage["default"];
  }
});
Object.defineProperty(exports, "SubstituteRuleProduct", {
  enumerable: true,
  get: function get() {
    return _SubstituteRuleProduct["default"];
  }
});
Object.defineProperty(exports, "SubstituteRulesApi", {
  enumerable: true,
  get: function get() {
    return _SubstituteRulesApi["default"];
  }
});
Object.defineProperty(exports, "Unauthorized", {
  enumerable: true,
  get: function get() {
    return _Unauthorized["default"];
  }
});
Object.defineProperty(exports, "ValidationError", {
  enumerable: true,
  get: function get() {
    return _ValidationError["default"];
  }
});

var _ApiClient = _interopRequireDefault(require("./ApiClient"));

var _AddProductToCurrentInventoryRequest = _interopRequireDefault(require("./model/AddProductToCurrentInventoryRequest"));

var _AppResourcesAwaitingValidationOrdersSchemasNeedsRange = _interopRequireDefault(require("./model/AppResourcesAwaitingValidationOrdersSchemasNeedsRange"));

var _AppResourcesInventoriesSchemasProduct = _interopRequireDefault(require("./model/AppResourcesInventoriesSchemasProduct"));

var _AppResourcesProductsSchemasProduct = _interopRequireDefault(require("./model/AppResourcesProductsSchemasProduct"));

var _AppResourcesPurchaseOrdersSchemasNeedsRange = _interopRequireDefault(require("./model/AppResourcesPurchaseOrdersSchemasNeedsRange"));

var _AwaitingDeliveryProductOrder = _interopRequireDefault(require("./model/AwaitingDeliveryProductOrder"));

var _AwaitingValidationOrder = _interopRequireDefault(require("./model/AwaitingValidationOrder"));

var _AwaitingValidationProductOrder = _interopRequireDefault(require("./model/AwaitingValidationProductOrder"));

var _BackendIssue = _interopRequireDefault(require("./model/BackendIssue"));

var _Category = _interopRequireDefault(require("./model/Category"));

var _CreateAwaitingDeliveryProductOrderRequest = _interopRequireDefault(require("./model/CreateAwaitingDeliveryProductOrderRequest"));

var _CreateAwaitingValidationProductOrderRequest = _interopRequireDefault(require("./model/CreateAwaitingValidationProductOrderRequest"));

var _CreateInventoryRequest = _interopRequireDefault(require("./model/CreateInventoryRequest"));

var _CreateOrUpdateSubstituteRuleProductRequest = _interopRequireDefault(require("./model/CreateOrUpdateSubstituteRuleProductRequest"));

var _CreateOrUpdateSubstituteRuleRequest = _interopRequireDefault(require("./model/CreateOrUpdateSubstituteRuleRequest"));

var _CurrencyCodeEnum = _interopRequireDefault(require("./model/CurrencyCodeEnum"));

var _DisableOutOfStockRequest = _interopRequireDefault(require("./model/DisableOutOfStockRequest"));

var _EnableOutOfStockRequest = _interopRequireDefault(require("./model/EnableOutOfStockRequest"));

var _Forbidden = _interopRequireDefault(require("./model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("./model/InternalServerError"));

var _Inventory = _interopRequireDefault(require("./model/Inventory"));

var _LocalizedProduct = _interopRequireDefault(require("./model/LocalizedProduct"));

var _LocalizedProductPage = _interopRequireDefault(require("./model/LocalizedProductPage"));

var _OutOfStock = _interopRequireDefault(require("./model/OutOfStock"));

var _OutOfStockPage = _interopRequireDefault(require("./model/OutOfStockPage"));

var _OutOfStockProduct = _interopRequireDefault(require("./model/OutOfStockProduct"));

var _PricingStrategy = _interopRequireDefault(require("./model/PricingStrategy"));

var _ProductCurrentStock = _interopRequireDefault(require("./model/ProductCurrentStock"));

var _ProductNeeds = _interopRequireDefault(require("./model/ProductNeeds"));

var _ProductProvider = _interopRequireDefault(require("./model/ProductProvider"));

var _ProductSubstitute = _interopRequireDefault(require("./model/ProductSubstitute"));

var _ProductSubstitutePage = _interopRequireDefault(require("./model/ProductSubstitutePage"));

var _Provider = _interopRequireDefault(require("./model/Provider"));

var _ProviderType = _interopRequireDefault(require("./model/ProviderType"));

var _PurchaseOrder = _interopRequireDefault(require("./model/PurchaseOrder"));

var _PurchaseOrderPage = _interopRequireDefault(require("./model/PurchaseOrderPage"));

var _Quantity = _interopRequireDefault(require("./model/Quantity"));

var _SearchOutOfStockRequest = _interopRequireDefault(require("./model/SearchOutOfStockRequest"));

var _SubstituteProduct = _interopRequireDefault(require("./model/SubstituteProduct"));

var _SubstituteRule = _interopRequireDefault(require("./model/SubstituteRule"));

var _SubstituteRulePage = _interopRequireDefault(require("./model/SubstituteRulePage"));

var _SubstituteRuleProduct = _interopRequireDefault(require("./model/SubstituteRuleProduct"));

var _Unauthorized = _interopRequireDefault(require("./model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("./model/ValidationError"));

var _AwaitingDeliveryOrdersApi = _interopRequireDefault(require("./api/AwaitingDeliveryOrdersApi"));

var _AwaitingValidationOrdersApi = _interopRequireDefault(require("./api/AwaitingValidationOrdersApi"));

var _InventoriesApi = _interopRequireDefault(require("./api/InventoriesApi"));

var _LocalizedProductsApi = _interopRequireDefault(require("./api/LocalizedProductsApi"));

var _OutOfStocksApi = _interopRequireDefault(require("./api/OutOfStocksApi"));

var _PurchaseOrdersApi = _interopRequireDefault(require("./api/PurchaseOrdersApi"));

var _SubstituteRulesApi = _interopRequireDefault(require("./api/SubstituteRulesApi"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }